(function () {
  'use strict';

  function keywordUrl(href) {
    var url = new URL(href, window.location.origin);
    var query = url.searchParams.get('q');
    if (!query) return url;
    var parts = query.split(' AND (handle:');
    var terms = parts[0].trim().replace(/\*+$/, '');
    if (!terms) return url;
    parts[0] = terms;
    var root = document.querySelector('[data-search-results-page]');
    var scope = root && root.dataset.searchScope;
    var scoped = parts.join(' AND (handle:');
    if (parts.length === 1 && scope && scope !== '()') scoped = terms + ' AND ' + scope;
    url.searchParams.set('q', scoped);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url;
  }

  if (document.querySelector('[data-search-results-page]')) {
    var currentUrl = new URL(window.location.href);
    var nextUrl = keywordUrl(currentUrl.href);
    if (nextUrl.href !== currentUrl.href) {
      window.location.replace(nextUrl.href);
      return;
    }
  }

  function init(root) {
    if (!root || root.dataset.searchResultsInitialized === 'true') return;
    root.dataset.searchResultsInitialized = 'true';

    root.querySelectorAll('a[href]').forEach(function (link) {
      if (new URL(link.href).pathname !== window.location.pathname) return;
      link.href = keywordUrl(link.href).href;
    });

    var toggle = root.querySelector('[data-search-filter-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var catalog = toggle.closest('[data-search-catalog]');
        if (!catalog) return;
        var collapsed = catalog.classList.toggle('is-filter-collapsed');
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    }

    root.querySelectorAll('[data-search-sort]').forEach(function (input) {
      input.addEventListener('change', function () { input.form.submit(); });
    });
  }

  document.querySelectorAll('[data-search-results-page]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-search-results-page]'));
  });
}());
